<div class="d-flex justify-content-between align-items-center mb-3">
  <h1 class="fs-5 fw-bold mb-0">Bot rules</h1>
  <div class="d-flex gap-2">
    <a [routerLink]="['add']" *isGranted="['ROLE_API_BOT_RULE_WRITE']" class="btn btn-primary fw-bold"><i
    class="bi bi-plus-lg me-2"></i>Add rule
  </a>
</div>
</div>

<div class="card border-0 shadow mb-3 fade-in-zoom">
  <div class="card-body">
    <div class="alert alert-info">All bots are <b>denied</b> by default. Rules are evaluated in order, and the first matching rule is applied.</div>

    <div class="table-responsive">
      <table class="table table-hover table-striped align-middle">
        <thead>
          <tr>
            <th>Order</th>
            <th>Name</th>
            <th>Rule</th>
            <th>Access</th>
            <th class="text-center">Action</th>
          </tr>
        </thead>
        <tbody>
          @for (botRule of botRules; track botRule; let isFirst = $first; let isLast = $last) {
            <tr>
              <td>{{ botRule.position }}</td>
              <td>{{ botRule.name }}</td>
              <td>{{ botRule.rule }}</td>
              <td>
                @if (botRule.allowed) {
                  <span class="badge bg-success">Allowed</span>
                }
                @if (!botRule.allowed) {
                  <span class="badge bg-danger">Denied</span>
                }
              </td>
              <td class="text-center">
                <button class="btn btn-primary btn-sm me-1" (click)="up(botRule)" [disabled]="isFirst"><i
                class="bi bi-arrow-up me-1"></i>Up
              </button>
              <button class="btn btn-primary btn-sm me-1" (click)="down(botRule)" [disabled]="isLast"><i
              class="bi bi-arrow-down me-1"></i>Down
            </button>
            <a class="btn btn-outline-primary btn-sm me-1" [routerLink]="[botRule.id]"><i class="bi bi-pencil me-1"></i>Edit</a>
            <button *isGranted="['ROLE_API_BOT_RULE_WRITE']" class="btn btn-outline-danger btn-sm" appConfirm
              (click)="delete(botRule)"><i class="bi bi-trash"></i></button>
            </td>
          </tr>
        }
      </tbody>
    </table>

    <app-paginator (pageChange)="refresh()" [paginator]="paginator"></app-paginator>
  </div>
</div>
</div>
